<script setup lang="ts">
import { ref } from 'vue'
import { getClasses } from '~/js/composables/classes'
import ButtonPrimary from '~/vue/_teammasters/atoms/buttons/ButtonPrimary.vue'

interface Options {
    view: string,
    text: string,
}

interface Props {
    options: Array<Options>|null,
    utilities?: string | null,
    on?: string | null,
}

const props = withDefaults(defineProps<Props>(), {
    options: () => [],
    utilities: '',
})
const emit = defineEmits(['activeFilter'])

const toggleValue = ref(props.on ?? (props.options?.length ? props.options?.[0]?.view : null))

const classes = {
    _default: {
        _default: 'shadow-xl',
        grid: 'grid grid-flow-col auto-cols-fr',
        display: 'rounded-full',
        color: 'bg-white',
    },
}

const onToggle = (toggle: string) => {
    if (toggle) {
        toggleValue.value = toggle
    }

    emit('activeFilter', toggleValue.value)
}
</script>

<template>
    <div :class="getClasses(classes, '_default')">
        <ButtonPrimary
            v-for="option in options"
            :key="option.view"
            :aria-pressed="option.view === toggleValue"
            :content="option.text"
            :show-icon="false"
            :theme="option.view === toggleValue ? 'light' : 'dark'"
            :utilities="`w-full !border-white !py-2 ${option.view !== toggleValue ? ' hover:!bg-white hover:!text-neutral-900' : 'hover:!bg-black hover:!text-white'}`"
            @click="onToggle(option.view)"
            type="button"
        />
    </div>
</template>
